import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { UtilService } from '@service/util/util.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';

@Component({
	selector: 'app-account-mapping',
	templateUrl: './account-mapping.component.html',
	styleUrls: ['./account-mapping.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMappingComponent implements OnInit {
	@Input() isCustomerCarrier: boolean = false;
	@Input() carrierId: string = null;
	@Output() customerCarrierUpdated: EventEmitter<any> = new EventEmitter();

	constructor(
		private urlService: UrlService,
		private restService: RestService,
		public utilService: UtilService,
		private cargochief: Cargochief
	) {}

	ngOnInit() {}

	accountMappedToggled(toggledValue: boolean) {
		toggledValue ? this.createAccountMap(toggledValue) : this.deleteAccountMap(toggledValue);
	}

	createAccountMap(toggledValue: boolean) {
		const url = this.urlService.createAccountMap();
		const payload = {
			accountId: this.cargochief.ACCOUNT_ID,
			carrierId: this.carrierId,
			accountMapped: toggledValue,
		};
		this.restService.POST(url, payload).subscribe(
			(result) => {
				this.customerCarrierUpdated.emit(toggledValue);
				this.utilService.showSnackbar(
					'The carrier has been added to your network.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.updateAccountCarrierMapCount(toggledValue);
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot setup carrier now. Please try again.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	deleteAccountMap(toggledValue: boolean) {
		const url = this.urlService.deleteAccountMap(this.carrierId, this.cargochief.ACCOUNT_ID);
		this.restService.DELETE(url).subscribe(
			(result) => {
				this.customerCarrierUpdated.emit(toggledValue);
				this.utilService.showSnackbar(
					'The carrier has been removed from your network.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.updateAccountCarrierMapCount(toggledValue);
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot setup carrier now. Please try again.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	updateAccountCarrierMapCount(isCarrierAdded: boolean) {
		let accountCarrierMapCount: any = this.cargochief.getItem(
			CARGOCHIEF_KEYS.ACCOUNT_CARRIER_MAP_COUNT
		);
		accountCarrierMapCount = !this.utilService.isNullOrUndefined(accountCarrierMapCount)
			? Number(JSON.parse(accountCarrierMapCount))
			: 0;
		if (isCarrierAdded) {
			accountCarrierMapCount += 1;
		} else {
			accountCarrierMapCount -= 1;
		}
		this.cargochief.setItem({
			[CARGOCHIEF_KEYS.ACCOUNT_CARRIER_MAP_COUNT]: accountCarrierMapCount,
		});
	}
}
